import { render } from "./BlockImageTextOffset.vue?vue&type=template&id=742e46fe"
import script from "./BlockImageTextOffset.vue?vue&type=script&lang=js"
export * from "./BlockImageTextOffset.vue?vue&type=script&lang=js"

import "./BlockImageTextOffset.vue?vue&type=style&index=0&id=742e46fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__